var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.601562 7.35938C0.601562 7.6875 0.716146 7.96875 0.945312 8.20312C1.17969 8.43229 1.46094 8.54688 1.78906 8.54688H6.125V12.8828C6.125 13.2057 6.23958 13.4818 6.46875 13.7109C6.69792 13.9453 6.97656 14.0625 7.30469 14.0625C7.63281 14.0625 7.91146 13.9453 8.14062 13.7109C8.375 13.4818 8.49219 13.2057 8.49219 12.8828V8.54688H12.8281C13.151 8.54688 13.4271 8.43229 13.6562 8.20312C13.8906 7.96875 14.0078 7.6875 14.0078 7.35938C14.0078 7.03125 13.8906 6.7526 13.6562 6.52344C13.4271 6.28906 13.151 6.17188 12.8281 6.17188H8.49219V1.84375C8.49219 1.51562 8.375 1.23698 8.14062 1.00781C7.91146 0.773438 7.63281 0.65625 7.30469 0.65625C6.97656 0.65625 6.69792 0.773438 6.46875 1.00781C6.23958 1.23698 6.125 1.51562 6.125 1.84375V6.17188H1.78906C1.46094 6.17188 1.17969 6.28906 0.945312 6.52344C0.716146 6.7526 0.601562 7.03125 0.601562 7.35938Z",
    fill: "#207BA5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.6c97582dc846078150c6f84524def355.svg";
export { ForwardRef as ReactComponent };